var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"c-avatar",class:_vm.imageClass,attrs:{"id":("avatar_" + _vm._uid)}},[(_vm.loading)?_c('loading'):_c('img',{attrs:{"src":_vm.userAvatar,"alt":_vm.imgAlt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }